import { type PageContext } from 'gatsby/internal';
import { type ReactNode } from 'react';
import { INFCON_PATH } from '../utils/urls';
import Infcon2023Layout from './Infcon2023Layout';

const Layout = ({
  children,
  pageContext,
  location
}: {
  children: ReactNode;
  pageContext: PageContext;
  location: Location;
}) => {
  if (location.pathname !== INFCON_PATH && location.pathname !== `${INFCON_PATH}/`) {
    return <Infcon2023Layout location={location}>{children}</Infcon2023Layout>;
  }
  return <>{children}</>;
};

export default Layout;
